<template>
  <router-view/>
</template>

<style lang="scss">

.bootstrap .table-borderless > :not(caption) > * > * {
  border: none;
}

.publications-table {
    margin-top: 50px;
    min-height: 500px;
    font-weight: 600;

    a, a:visited {
      color: #385EAC;
      font-weight: 600;
      text-decoration: underline !important;
    }

    a:hover {
      color: #39A95E;
    }

    @media only screen and (max-width: 800px) {
      overflow-x: auto;

      #app {
        overflow-x: auto;
      }
    }

    tr:nth-child(even) {
      background-color: #EDF3FEB3;
    }

    table {
      transition: opacity 0.2s ease-in-out;
    }

    table tbody {
      min-height: 500px;
      border: none;
    }

    thead.sort-asc {
      svg {
        transform: translateY(5px);
      }
    }

    thead.sort-desc {
      svg {
        transform: rotate(180deg) translateY(5px);
      }
    }

    thead > tr > th {
      cursor: pointer;

      span {
        color: #39A95E;
        text-transform: uppercase;
      }

      &.column-media {
        cursor: auto;
      }

      & > span {
        display: flex;
        align-items: end;
      }
      svg {
        min-width: 20px;
        min-height: 20px;
        width: 20px;
        height: 20px;
      }
    }

    table.loading {
      opacity: 0.5;

      thead > tr > th {
        pointer-events: none;
      }
    }

    button {
      opacity: 1;
    }

    button.loading {
      opacity: 0.5;
      pointer-events: none;
    }

    .publications-search-container {
        input, span.input-group-text {
            background-color: #F3F3F3;
            border: 0px;
        }

        input:focus {
            background-color: #F3F3F3;
            box-shadow: none;
        }
    }

    .box {
        background-color: #F4F9FF;
        border: 1px solid #95A9C2;
        border-radius: 15px;
        overflow: hidden;

        .card-body {
            background-color: #F4F9FF;
        }

        & > .row:first-child {
            padding-top: 25px;
            padding-bottom: 25px;
        }

        span {
            font-weight: 600;
        }

        strong {
            display: block;
            color: #2E4D8B;

            & > span {
                color: #5A5A5B;
                font-weight: 600;
            }
        }
    }

    .collapse-icon {
        padding-left: 25px;
        padding-right: 25px;
        font-size: 3rem;
    }

    .institution-icon {
        min-width: 125px;
        text-align: center;

        img {
            width: 100%;
            max-width: 75px;
        }
    }


    @media only screen and (min-width: 921px) {
      td.col-year {
        text-align: center;
      }

      .w-35 {
        width: 36% !important;
      }

      td.col-media {
        min-width: 140px;
        span {
            display: block;
        }
      }
    }

    @media only screen and (max-width: 920px) {
      thead th {
          display: none;
      }

      td, th {
          display: block;
      }

      td[data-th]:before  {
          content: attr(data-th);
      }

      .table>tbody>tr>td, .table>tfoot>tr>td, .table>thead>tr>td {
        padding-bottom: 2px;
        padding-top: 2px;
      }

      .table>tbody>tr>td:first-child {
        padding-top: 15px;
      }

      .table>tbody>tr>td:last-child {
        padding-bottom: 15px;
      }

      td.col-media span + span:before {
        content:', ';
      }

      td.col-authors {
        font-style: italic;
        font-weight: 500;
        padding-bottom: 5px !important;
        padding-top: 5px !important;
      }

    }
}
</style>
